module.exports = __webpack_public_path__ + "dee0e55f8f4c43c313a6459b0fdd0eb8.obj";